import React from 'react';
import { Button, CloseButton } from '@fiverr-private/button';
import { Container, Grid, GridItem } from '@fiverr-private/layout_components';
import { ArrowLeftIcon } from '@fiverr-private/visuals';
import { translate } from '../../../utils/translate';
import { useIdentificationContext } from '../../IdentificationContext';
import { useBreakpointMd } from '../../../hooks/useBreakpoint';
import * as classes from './NavigationBar.styles.ve.css';

export interface NavigationBarProps {
    fiverrLogo: React.ReactNode;
    hideCloseBtn?: boolean;
    hasBack: boolean;
    goBack(): void;
}

export const NavigationBar: React.FC<NavigationBarProps> = ({ fiverrLogo, goBack, hasBack, hideCloseBtn = false }) => {
    const { isModal, isSticky, closeModal } = useIdentificationContext();
    const isMdScreen = useBreakpointMd();
    const isCloseBtnHideCondition = isSticky || isMdScreen;
    const withCloseBtn = hideCloseBtn ? false : !isCloseBtnHideCondition;

    return (
        <Container
            height={{
                default: '60px',
                sm: '72px',
            }}
            flexShrink="0"
            alignItems="center"
            display="flex"
        >
            <Grid minHeight="40px" width="100%" templateColumns={hasBack ? '33%_33%_33%' : '50%_50%'}>
                {hasBack && (
                    <GridItem display="flex" justifyContent="flexStart" alignItems="center">
                        <Button size="md" className={classes.button} onClick={goBack} variant="ghost">
                            <Container display={{ default: 'block', md: 'none' }}>
                                <ArrowLeftIcon size="md" />
                            </Container>
                            <Container display={{ default: 'none', md: 'flex' }} alignItems="center" gap="2">
                                <ArrowLeftIcon size="sm" />
                                <Container as="span">{translate('general.back')}</Container>
                            </Container>
                        </Button>
                    </GridItem>
                )}

                {isModal && (
                    <GridItem
                        display={{ default: 'flex', md: 'none' }}
                        justifyContent={hasBack ? 'center' : 'flexStart'}
                        alignItems="center"
                    >
                        {fiverrLogo}
                    </GridItem>
                )}

                {isModal && withCloseBtn && (
                    <>
                        <Container
                            position="absolute"
                            top="0px"
                            right="0px"
                            marginTop={{ default: '2', sm: '4' }}
                            marginRight={{ default: '2.5', sm: '4' }}
                        >
                            <CloseButton onClick={closeModal} />
                        </Container>
                    </>
                )}
            </Grid>
        </Container>
    );
};
